import * as React from 'react';
import { Box } from '@mui/material';
import ProfileModal from './profile-modal';

interface IUserModalProps {
  open: boolean;
  handleClose: () => void;
}

const MODALS = {
  PROFILE: 1,
  PROFILEPICTURE: 2,
  CHANGEPROFILEPICTURE: 3,
  TELNOMODAL: 4
};

export default function UserModal({
  open,
  handleClose
}: IUserModalProps): JSX.Element {
  const [openModal, setOpenModal] = React.useState(MODALS.PROFILE);
  const handleProfilePictureModalOpen = (): void => {
    setOpenModal(MODALS.PROFILEPICTURE);
  };

  const handleTelNoModalOpen = (): void => {
    setOpenModal(MODALS.TELNOMODAL);
  };

  const profileModal = (
    <ProfileModal
      open={open}
      handleClose={handleClose}
      handleProfilePictureModalOpen={handleProfilePictureModalOpen}
      handleTelNoModalOpen={handleTelNoModalOpen}
    />
  );

  return <Box>{openModal === MODALS.PROFILE && profileModal}</Box>;
}
